import {
    HttpErrorResponse,
    HttpHeaders,
    HttpInterceptorFn,
    HttpParams
} from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppService } from '@/service/app.service';

export const apiInterceptor: HttpInterceptorFn = (request, next) => {
    const appService: AppService = inject(AppService);

    const headersConfig: Record<string, string> = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    if (request.reportProgress) {
        delete headersConfig['Content-Type'];
    }
    let params: HttpParams = request.params;
    const reqHeaders: HttpHeaders = request.headers;
    if (reqHeaders.has('Accept')) {
        delete headersConfig['Accept'];
    }

    const cloned = request.clone({ setHeaders: headersConfig, params });

    return next(cloned).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.error?.message) {
                appService.toast(error.error.message, 'error');
            }

            return throwError(() => error);
        })
    );
};
